import type { TypeFormFieldElement } from '../../../types/form';

import isFormFieldElement from './isFormFieldElement';

// ----------------------------------------------------------------------------

function getFormFields(form: HTMLFormElement): TypeFormFieldElement[] {
    return Array.from(form.elements).filter(isFormFieldElement);
}

// ----------------------------------------------------------------------------

export default getFormFields;
